// TODO: Remove one of copy this enum
export enum FeatureName {
  // aggregates Apache Camel
  AGGREGATION = 'aggregation',
  // interpolation of variables in the editor of Workflow
  VARIABLES = 'variables',
  // versions workflow changes
  VERSIONS = 'versions',
  // experimental features. they are not tested yet
  EXPIREMENTAL = 'expiremental',
}
